import constants from '@/constants';
import utils from '@/utils';
import rest from "../../restUtils";
import router from '@/router';

const emptyUser = {
    name: '',
    username: '',
    email: '',
    birthday: '',
    birthAddress: {
        name: '',
        lat: '',
        lng: ''
    },
    currentAddress: {
        name: '',
        lat: '',
        lng: ''
    },
    role: ''
};

export default {
    namespace: true,
    state: {
        user: Object.assign({}, emptyUser),
        token: ''
    },

    actions: {
        async authorization({commit, dispatch, getters}, user) {
            try {
                let tokenData = await rest.doPost(
                        `/auth/signin`,
                        {
                            usernameOrEmail: user.username,
                            password: user.password
                        });
                commit('AUTH_SUCCESS', tokenData);
            } catch (error) {
                commit('AUTH_ERROR');
                return;
            }

            try {
                await dispatch('loadCurrentUserData');

                let redirectTo = sessionStorage.getItem(constants.SESSION_STORAGE_REDIRECT);
                if (redirectTo && redirectTo.length > 0) {
                    sessionStorage.removeItem(constants.SESSION_STORAGE_REDIRECT);
                    router.push(redirectTo);
                } else {
                    let userRole = getters.currentUser.role;
                    if (['ROLE_SUPER', 'ROLE_ADMIN'].includes(userRole)) {
                        router.push({name: 'Cabinet'});
                    } else {
                        router.push({name: 'CardCalculate'});
                    }
                }
            } catch (error) {
                dispatch('logout');
            }
        },

        async authByToken({commit, dispatch}, token) {
            try {
                let tokenData = await rest.doPost(
                        `/auth/signin-by-token?autoAuthToken=${token}`);
                commit('AUTH_SUCCESS', tokenData);
            } catch (error) {
                commit('AUTH_ERROR', {
                    silently: true
                });
                return;
            }

            try {
                await dispatch('loadCurrentUserData');

                let redirectTo = sessionStorage.getItem(constants.SESSION_STORAGE_REDIRECT);
                if (redirectTo && redirectTo.length > 0) {
                    sessionStorage.removeItem(constants.SESSION_STORAGE_REDIRECT);
                    router.push(redirectTo);
                }
            } catch (error) {
                dispatch('logout');
            }
        },

        async registration(context, user) {
            let success;
            try {
                await rest.doPost(
                        `/auth/signup`,
                        {
                            name: user.name,
                            email: user.email,
                            birthday: user.birthday,
                            birthAddress: user.birthAddress
                        });
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        },

        async isAuthenticated({commit, dispatch, getters}) {
            let token = getters.token;
            let authenticated = token && token.length > 0;

            if (!authenticated) {
                let tokenFromStorage = sessionStorage.getItem(constants.SESSION_STORAGE_TOKEN);
                if (tokenFromStorage)
                    authenticated = await dispatch('loadCurrentUserData');
            }

            return !!authenticated;
        },

        async loadCurrentUserData({commit}) {
            let success;
            try {
                let userData = await rest.doGet(`/user/current-user`);
                commit('LOAD_USER_DATA', userData);
                success = true;
            } catch (error) {
                success = false;
            }

            return success;
        },

        async updateUserData({commit}, user) {
            let success;
            try {
                let userData = await rest.doPut(`/user`, user);
                commit('LOAD_USER_DATA', userData);
                success = true;
            } catch (error) {
                alert(error.response.data.message);
                success = false;
            }

            return success;
        },

        setNewPassword(context, password) {
            return rest.doPost(`/user/new-password`, password);
        },

        refreshPassword(context, email) {
            return rest.doPost(`/user/forgot-password`, email);
        },

        setSocialToken({commit}, token) {
            commit('AUTH_SOCIAL_SUCCESS', token);
        },

        logout({commit}) {
            commit('LOGOUT');
            commit('setCurrentSubscription', null);
        }
    },

    mutations: {
        AUTH_SOCIAL_SUCCESS(state, token) {
            state.token = token;
            sessionStorage.setItem(constants.SESSION_STORAGE_TOKEN, token);
        },

        AUTH_SUCCESS(state, user) {
            state.token = user.accessToken;
            state.role = user.role;
            sessionStorage.setItem(constants.SESSION_STORAGE_TOKEN, user.accessToken);
        },

        AUTH_ERROR(state, payload) {
            state.token = '';
            state.user = Object.assign({}, emptyUser);
            if (!payload || !payload.silently)
                alert('Неверные данные аутентификации!')
        },

        LOGOUT(state) {
            state.token = '';
            state.user = Object.assign({}, emptyUser);
            sessionStorage.removeItem(constants.SESSION_STORAGE_TOKEN);
        },

        LOAD_USER_DATA(state, payload) {
            let payloadWithUTCDate = Object.assign({}, payload);
            if (!!payload.birthday || payload.birthday == 0) {
                Object.assign(payloadWithUTCDate, {
                    birthday: utils.convertDateToUTC(new Date(payload.birthday))
                });
            }
            Object.assign(state.user, payloadWithUTCDate);
        }
    },

    getters: {
        currentUser: state => state.user,
        token: state => state.token,
    }
};